/* ============================================================
   STAFFLINE TRANSPORT – ALL ROUTES DATA
   ============================================================
   Each route contains:
   - id               (unique number)
   - routeName        (Origin → Destination)
   - routeStart       (Morning pickup begins here)
   - routeEnd         (Final workplace drop-off)
   - routePoints      (Major bus stops – pickup in morning / drop-off at work)
                      * In the evening, the process reverses:
                        pickup at work → drop-off at the same points
   - routeDuration    (Estimated travel time)
   - routeDistance    (Estimated distance)
   - routePrice       (800 GHS flat for all routes)
   ============================================================ */

export const routesData = [
  /* ==========================================================
     KASOA ROUTES (4 Routes)
     ========================================================== */
  {
    id: 1,
    routeName: "Kasoa → Accra Central",
    routeStart: "Kasoa Main Station",
    routeEnd: "Accra Central",
    routePoints: [
      { name: "Kasoa Main Station", time: "6:30 AM" },
      { name: "Mallam Junction", time: "6:50 AM" },
      { name: "Kaneshie", time: "7:10 AM" },
      { name: "Circle", time: "7:25 AM" },
      { name: "Accra Central", time: "8:00 AM" },
    ],
    routeDuration: "~45 minutes",
    routeDistance: "~30 km",
    routePrice: 800,
  },
  {
    id: 2,
    routeName: "Kasoa → Osu",
    routeStart: "Kasoa Main Station",
    routeEnd: "Osu",
    routePoints: [
      { name: "Kasoa Main Station", time: "6:30 AM" },
      { name: "Mallam Junction", time: "6:50 AM" },
      { name: "Kaneshie", time: "7:10 AM" },
      { name: "Osu", time: "7:50 AM" },
    ],
    routeDuration: "~40 minutes",
    routeDistance: "~28 km",
    routePrice: 800,
  },
  {
    id: 3,
    routeName: "Kasoa → North Industrial Area",
    routeStart: "Kasoa Main Station",
    routeEnd: "North Industrial Area",
    routePoints: [
      { name: "Kasoa Main Station", time: "6:30 AM" },
      { name: "Mallam Junction", time: "6:50 AM" },
      { name: "Kaneshie", time: "7:10 AM" },
      { name: "North Industrial Area", time: "7:55 AM" },
    ],
    routeDuration: "~50 minutes",
    routeDistance: "~32 km",
    routePrice: 800,
  },
  {
    id: 4,
    routeName: "Kasoa → South Industrial Area",
    routeStart: "Kasoa Main Station",
    routeEnd: "South Industrial Area",
    routePoints: [
      { name: "Kasoa Main Station", time: "6:30 AM" },
      { name: "Mallam Junction", time: "6:50 AM" },
      { name: "Kaneshie", time: "7:10 AM" },
      { name: "South Industrial Area", time: "8:00 AM" },
    ],
    routeDuration: "~55 minutes",
    routeDistance: "~35 km",
    routePrice: 800,
  },

  /* ==========================================================
     AMASAMAN ROUTES (4 Routes)
     ========================================================== */
  {
    id: 5,
    routeName: "Amasaman → Accra Central",
    routeStart: "Amasaman Main Station",
    routeEnd: "Accra Central",
    routePoints: [
      { name: "Amasaman Main Station", time: "6:30 AM" },
      { name: "Achimota", time: "6:55 AM" },
      { name: "Circle", time: "7:15 AM" },
      { name: "Accra Central", time: "7:45 AM" },
    ],
    routeDuration: "~40 minutes",
    routeDistance: "~25 km",
    routePrice: 800,
  },
  {
    id: 6,
    routeName: "Amasaman → Osu",
    routeStart: "Amasaman Main Station",
    routeEnd: "Osu",
    routePoints: [
      { name: "Amasaman Main Station", time: "6:30 AM" },
      { name: "Achimota", time: "6:55 AM" },
      { name: "Circle", time: "7:15 AM" },
      { name: "Osu", time: "7:40 AM" },
    ],
    routeDuration: "~38 minutes",
    routeDistance: "~23 km",
    routePrice: 800,
  },
  {
    id: 7,
    routeName: "Amasaman → North Industrial Area",
    routeStart: "Amasaman Main Station",
    routeEnd: "North Industrial Area",
    routePoints: [
      { name: "Amasaman Main Station", time: "6:30 AM" },
      { name: "Achimota", time: "6:55 AM" },
      { name: "North Industrial Area", time: "7:45 AM" },
    ],
    routeDuration: "~45 minutes",
    routeDistance: "~28 km",
    routePrice: 800,
  },
  {
    id: 8,
    routeName: "Amasaman → South Industrial Area",
    routeStart: "Amasaman Main Station",
    routeEnd: "South Industrial Area",
    routePoints: [
      { name: "Amasaman Main Station", time: "6:30 AM" },
      { name: "Achimota", time: "6:55 AM" },
      { name: "South Industrial Area", time: "7:50 AM" },
    ],
    routeDuration: "~48 minutes",
    routeDistance: "~30 km",
    routePrice: 800,
  },

  /* ==========================================================
     ABURI ROUTES (4 Routes)
     ========================================================== */
  {
    id: 9,
    routeName: "Aburi → North Industrial Area",
    routeStart: "Aburi Main Station",
    routeEnd: "North Industrial Area",
    routePoints: [
      { name: "Aburi Main Station", time: "5:45 AM" },
      { name: "Achimota", time: "6:35 AM" },
      { name: "North Industrial Area", time: "7:25 AM" },
    ],
    routeDuration: "~1 hour 40 min",
    routeDistance: "~40 km",
    routePrice: 800,
  },
  {
    id: 10,
    routeName: "Aburi → South Industrial Area",
    routeStart: "Aburi Main Station",
    routeEnd: "South Industrial Area",
    routePoints: [
      { name: "Aburi Main Station", time: "5:45 AM" },
      { name: "Achimota", time: "6:35 AM" },
      { name: "South Industrial Area", time: "7:30 AM" },
    ],
    routeDuration: "~1 hour 45 min",
    routeDistance: "~42 km",
    routePrice: 800,
  },
  {
    id: 11,
    routeName: "Aburi → Ministries",
    routeStart: "Aburi Main Station",
    routeEnd: "Ministries",
    routePoints: [
      { name: "Aburi Main Station", time: "5:45 AM" },
      { name: "Achimota", time: "6:35 AM" },
      { name: "Circle", time: "7:05 AM" },
      { name: "Ministries", time: "7:30 AM" },
    ],
    routeDuration: "~1 hour 45 min",
    routeDistance: "~38 km",
    routePrice: 800,
  },
  {
    id: 12,
    routeName: "Aburi → Accra Central",
    routeStart: "Aburi Main Station",
    routeEnd: "Accra Central",
    routePoints: [
      { name: "Aburi Main Station", time: "5:45 AM" },
      { name: "Achimota", time: "6:35 AM" },
      { name: "Circle", time: "7:05 AM" },
      { name: "Accra Central", time: "7:25 AM" },
    ],
    routeDuration: "~1 hour 40 min",
    routeDistance: "~35 km",
    routePrice: 800,
  },

  /* ==========================================================
     ASHIAMAN ROUTES (4 Routes)
     ========================================================== */
  {
    id: 13,
    routeName: "Ashiaman → North Industrial Area",
    routeStart: "Ashiaman Main Station",
    routeEnd: "North Industrial Area",
    routePoints: [
      { name: "Ashiaman Main Station", time: "6:00 AM" },
      { name: "Tema Motorway", time: "6:25 AM" },
      { name: "North Industrial Area", time: "7:15 AM" },
    ],
    routeDuration: "~1 hour 15 min",
    routeDistance: "~22 km",
    routePrice: 800,
  },
  {
    id: 14,
    routeName: "Ashiaman → South Industrial Area",
    routeStart: "Ashiaman Main Station",
    routeEnd: "South Industrial Area",
    routePoints: [
      { name: "Ashiaman Main Station", time: "6:00 AM" },
      { name: "Tema Motorway", time: "6:25 AM" },
      { name: "South Industrial Area", time: "7:20 AM" },
    ],
    routeDuration: "~1 hour 20 min",
    routeDistance: "~25 km",
    routePrice: 800,
  },
  {
    id: 15,
    routeName: "Ashiaman → Osu",
    routeStart: "Ashiaman Main Station",
    routeEnd: "Osu",
    routePoints: [
      { name: "Ashiaman Main Station", time: "6:00 AM" },
      { name: "Tema Motorway", time: "6:25 AM" },
      { name: "Osu", time: "7:15 AM" },
    ],
    routeDuration: "~1 hour 10 min",
    routeDistance: "~20 km",
    routePrice: 800,
  },
  {
    id: 16,
    routeName: "Ashiaman → Accra Central",
    routeStart: "Ashiaman Main Station",
    routeEnd: "Accra Central",
    routePoints: [
      { name: "Ashiaman Main Station", time: "6:00 AM" },
      { name: "Tema Motorway", time: "6:25 AM" },
      { name: "Accra Central", time: "7:05 AM" },
    ],
    routeDuration: "~1 hour",
    routeDistance: "~18 km",
    routePrice: 800,
  },

  /* ==========================================================
     TEMA ROUTES (4 Routes)
     ========================================================== */
  {
    id: 17,
    routeName: "Tema → Osu",
    routeStart: "Tema Main Station",
    routeEnd: "Osu",
    routePoints: [
      { name: "Tema Main Station", time: "6:00 AM" },
      { name: "Tema Motorway", time: "6:20 AM" },
      { name: "Osu", time: "7:10 AM" },
    ],
    routeDuration: "~1 hour 10 min",
    routeDistance: "~30 km",
    routePrice: 800,
  },
  {
    id: 18,
    routeName: "Tema → North Industrial Area",
    routeStart: "Tema Main Station",
    routeEnd: "North Industrial Area",
    routePoints: [
      { name: "Tema Main Station", time: "6:00 AM" },
      { name: "Tema Motorway", time: "6:20 AM" },
      { name: "North Industrial Area", time: "7:05 AM" },
    ],
    routeDuration: "~1 hour 5 min",
    routeDistance: "~28 km",
    routePrice: 800,
  },
  {
    id: 19,
    routeName: "Tema → South Industrial Area",
    routeStart: "Tema Main Station",
    routeEnd: "South Industrial Area",
    routePoints: [
      { name: "Tema Main Station", time: "6:00 AM" },
      { name: "Tema Motorway", time: "6:20 AM" },
      { name: "South Industrial Area", time: "7:10 AM" },
    ],
    routeDuration: "~1 hour 10 min",
    routeDistance: "~32 km",
    routePrice: 800,
  },
  {
    id: 20,
    routeName: "Tema → Accra Central",
    routeStart: "Tema Main Station",
    routeEnd: "Accra Central",
    routePoints: [
      { name: "Tema Main Station", time: "6:00 AM" },
      { name: "Tema Motorway", time: "6:20 AM" },
      { name: "Accra Central", time: "7:15 AM" },
    ],
    routeDuration: "~1 hour 15 min",
    routeDistance: "~35 km",
    routePrice: 800,
  },

  /* ==========================================================
     DARKUMAN ROUTES (4 Routes) – Passes Lapaz, Circle
     ========================================================== */
  {
    id: 21,
    routeName: "Darkuman → Accra Central",
    routeStart: "Darkuman Main Station",
    routeEnd: "Accra Central",
    routePoints: [
      { name: "Darkuman Main Station", time: "6:15 AM" },
      { name: "Lapaz", time: "6:30 AM" },
      { name: "Kwame Nkrumah Circle", time: "6:55 AM" },
      { name: "Accra Central", time: "7:20 AM" },
    ],
    routeDuration: "~50 minutes",
    routeDistance: "~15 km",
    routePrice: 800,
  },
  {
    id: 22,
    routeName: "Darkuman → Osu",
    routeStart: "Darkuman Main Station",
    routeEnd: "Osu",
    routePoints: [
      { name: "Darkuman Main Station", time: "6:15 AM" },
      { name: "Lapaz", time: "6:30 AM" },
      { name: "Kwame Nkrumah Circle", time: "6:55 AM" },
      { name: "Osu", time: "7:15 AM" },
    ],
    routeDuration: "~45 minutes",
    routeDistance: "~13 km",
    routePrice: 800,
  },
  {
    id: 23,
    routeName: "Darkuman → North Industrial Area",
    routeStart: "Darkuman Main Station",
    routeEnd: "North Industrial Area",
    routePoints: [
      { name: "Darkuman Main Station", time: "6:15 AM" },
      { name: "Lapaz", time: "6:30 AM" },
      { name: "Kwame Nkrumah Circle", time: "6:55 AM" },
      { name: "North Industrial Area", time: "7:25 AM" },
    ],
    routeDuration: "~55 minutes",
    routeDistance: "~17 km",
    routePrice: 800,
  },
  {
    id: 24,
    routeName: "Darkuman → South Industrial Area",
    routeStart: "Darkuman Main Station",
    routeEnd: "South Industrial Area",
    routePoints: [
      { name: "Darkuman Main Station", time: "6:15 AM" },
      { name: "Lapaz", time: "6:30 AM" },
      { name: "Kwame Nkrumah Circle", time: "6:55 AM" },
      { name: "South Industrial Area", time: "7:30 AM" },
    ],
    routeDuration: "~1 hour",
    routeDistance: "~18 km",
    routePrice: 800,
  },
];

/* ============================================================
   HELPER: Get unique origin hubs for filters
   ============================================================ */
export const originHubs = [
  "Kasoa",
  "Amasaman",
  "Aburi",
  "Ashiaman",
  "Tema",
  "Darkuman",
];

/* ============================================================
   HELPER: Get unique destination hubs for filters
   ============================================================ */
export const destinationHubs = [
  "Accra Central",
  "Osu",
  "North Industrial Area",
  "South Industrial Area",
  "Ministries",
];